import * as moment from 'moment';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

export class Utility {  
  static GetFormattedDate(date: any): string {
    const newDate = new Date(date);
    const day = this.GetDate(newDate.getDate());
    const month = this.GetMonth(newDate.getMonth());
    const year = newDate.getFullYear();
    return day + '.' + month + '.' + year;
  }

  static GetFormattedDateTime(date: any): string {
    const newDate = new Date(date);
    const day = this.GetDate(newDate.getDate());
    const month = this.GetMonth(newDate.getMonth());
    const year = newDate.getFullYear();
    const hour= newDate.getHours();
    const minute= newDate.getMinutes();
    let response:string= day + '.' + month + '.' + year + ' ' + hour + ':' +( minute===0 ? '00': minute);
    return response;
  }

  static getDateStringToDate(date: string): Date {
    if (date) {
      var arr = date.split('.').reverse().join('-');
      if(date.includes('-'))
      {
        arr = date.split('-').reverse().join('-');
      }
      return new Date(arr);
    }
    return new Date();
  }

  static getDateStringToDateTimeForMechanic(dateTime:string):Date{
    if (dateTime) {
      var date=dateTime.split(' ');
      var arr = date[0].split('.').reverse().join('-');
      arr= arr+' '+date[1];
      if(date[0].includes('-'))
      {
        arr = date[0].split('-').reverse().join('-');
      }
      return new Date(arr);
    }
    return null;
  }


  static GetMonth = (month: number) => {
    return ('0' + (month + 1)).slice(-2);
  }

  static GetDate = (date: number) => {
    return ('0' + date).slice(-2);
  }

  static isDigit(event): boolean {

    if (event && event.which) {
      if (event.which < 48 || event.which > 57) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }
  static isDecimalPoint(event): boolean {
    if (event && event.which) {
      return event.which === 46;
    } else {
      return false;
    }
  }

  static createMessage(
    firstText: string,
    secondText: string,
    removeLastChar: boolean
  ) {
    var newSecondText;
    if (removeLastChar) {
      newSecondText = secondText.slice(0, -1).toLowerCase();
    } else {
      newSecondText = secondText.toLowerCase();
    }
    return firstText + ' ' + newSecondText + '?';
  }
  static monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

  static ConvertLocalTimeToUTCDate(time:string){
    var cdt = moment(time, 'HH:mm');
    var utcDateString = cdt.toISOString();
    return utcDateString;
  }
  static ConvertUTCDateToLocalTime(date:any){
    var localTime = moment.utc(date).local().format('HH:mm');
    return localTime;
  }
  
  static ConvertLocalDateToUTCDate(date:any){
    var utcDate = moment.parseZone(date).utc().format('MM/DD/YYYY HH:mm');
    return utcDate;
  }
  static ConvertUTCDateToLocalDate(date:Date){
    var localDate = moment.utc(date).local().format();
    return new Date(localDate);
  }
  static ConvertTimeToMinutes(hhmmString:string){
    let min = hhmmString.split(':');
    return ((parseInt(min[0])*60) + (parseInt(min[1])))
  }
  static ConvertMinutesToTime(minString:string){
    var hours = Utility.FormattedTime(Math.floor((parseInt(minString)) / 60));          
    var minutes = Utility.FormattedTime((parseInt(minString)) % 60);
    return hours + ':' + minutes
  }
  static FormattedTime(n) {
    n = String(n)
    if (n.length == 1)
      n = '0' + n
    return n
  }

  static getFullWeeksStartAndEndInMonth (month, year) {
    let weeks = [],
        firstDate = new Date(year, month, 1),
        lastDate = new Date(year, month + 1, 0),
        numDays = lastDate.getDate()

    let start = 1
    let end
    if (firstDate.getDay() === 1) {
        end = 7
    } else if (firstDate.getDay() === 0) {
        let preMonthEndDay = new Date(year, month, 0)
        start = preMonthEndDay.getDate() - 6 + 1
        end = 1
    } else {
        let preMonthEndDay = new Date(year, month, 0)
        start = preMonthEndDay.getDate() + 1 - firstDate.getDay() + 1
        end = 7 - firstDate.getDay() + 1
        weeks.push({
            start: start,
            end: end
        })
        start = end + 1
        end = end + 7
    }
    while (start <= numDays) {
        weeks.push({
            start: start,
            end: end
        });
        start = end + 1;
        end = end + 7;
        end = start === 1 && end === 8 ? 1 : end;
        if (end > numDays && start <= numDays) {
            end = end - numDays
            weeks.push({
                start: start,
                end: end
            })
            break
        }
    }
    return weeks.map(({start, end}, index) => {
        const sub = +(start > end && index === 0);
        return Array.from({length: 7}, (_, index) => {
            const date = new Date(year, month - sub, start + index);
            return {
                date: date.getDate(),
                month: date.toLocaleString('en', {month: 'long'}),
                day: date.toLocaleString('en', {weekday: 'long'}),
                wholeDate:date
            };
        });
    })//.flat(Infinity)
;
}

static GetTimeDuration(startDate: any, endDate: any){
  if (startDate && endDate) {
    let duration = moment.duration(moment(endDate).diff(moment(startDate))).asMinutes();
    return moment.utc(moment.duration(duration, "minutes").asMilliseconds()).format("HH:mm:ss"); 
  }
  else{
    return "";
  }
}

static base64toBlob = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

  static getDateFromMonthString(month: string, getFristDate: boolean): Date {
    if(getFristDate) {
      if (month && month.includes('-')) {
        var data = month.split('-');
        if (!isNullOrUndefined(data) && data.length == 2) {
          return new Date(Number(data[0]), Number(data[1]) - 1, 1);
        }
      }
      return new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    }
    else {
      if (month && month.includes('-')) {
        var data = month.split('-');
        if (!isNullOrUndefined(data) && data.length == 2) {
          return new Date(Number(data[0]), Number(data[1]), 0);
        }
      }
      return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    }
  }

  static GetEfficientPlanningTime(Efficiency:number, PlanningTime:number){
    return Math.ceil((PlanningTime/(Efficiency/100.00)) * 1.0 /15 * 15) ;
   }

  static GetActualPlanningTime(Efficiency:number, DurationInMin: number){
    return ((Efficiency*DurationInMin)*100);
  }

  static toHoursAndMinutes(totalMinutes) {
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    return (("0" + hours).slice(-2)) + ':' + (("0" + minutes).slice(-2)) ;
  }

  static toHoursAndMinutesAndSecond(seconds) {
    seconds = Number(seconds);
    // var d = Math.floor(seconds / (3600*24));
    // var h = Math.floor(seconds % (3600*24) / 3600);
    var h = Math.floor(seconds / (3600));
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);
    
    //var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
    // var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    // var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    // var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    // return  hDisplay + mDisplay + sDisplay;
    return (("0" + h).slice(-2)) + ':' + (("0" + m).slice(-2)) + ':' + (("0" + s).slice(-2)) ;
  }

  static ConvertToTimeFormat(date:any){
    var localTime = new Date(date).toTimeString().split(' ')[0];
    return localTime;
  }

  static ConvertLocalTimeToDateTime(time:string){
    var cdt = moment(time, 'HH:mm').toDate()
    var dateString=cdt.toLocaleString('en-US');
    return dateString;
  }


  static ConvertDecimalHourToHourMinute(Hour:number){
    const n = new Date(0,0);
    n.setMinutes(+Math.round(Hour * 60)); 
    const hours = n.getHours()
    const minutes = n.getMinutes()

    const hoursVal= hours.toString().length===1 ? '0'+hours : hours;
    const minutesVal= minutes.toString().length===1 ? '0'+minutes : minutes;
    return hoursVal + ':' + minutesVal;
  }

  static GetPriceInludingVAT(price,VATPercentage)
  {
    return ((+ price) + ((+ price)*VATPercentage)/100);
  }

  static GetDaysOfNextMonth(currentDate){
    const currentMonth = currentDate.getMonth();
    const nextMonthDate = new Date(currentDate);
    nextMonthDate.setMonth(currentMonth + 1);
    nextMonthDate.setDate(0);
    const daysInNextMonth = nextMonthDate.getDate();
    return daysInNextMonth;
  }
  
  static IsInBetweenDateTime(startDate, endDate,actualDate)
  {
    const startDateTime = moment(startDate, 'HH:mm');
    const endDateTime = moment(endDate, 'HH:mm');
    const actualDateTime = moment(actualDate, 'HH:mm');
    return actualDateTime.isSameOrAfter(startDateTime) && actualDateTime.isBefore(endDateTime);
  }

  static IsInBetweenTime(startDate, endDate,actualDate){
    const format = 'hh:mm:ss';

    // var time = moment() gives you current time. no format required.
    const time = moment(actualDate, format);
    const beforeTime = moment(startDate, format);
    const afterTime = moment(endDate, format);

    if (time.isBetween(beforeTime, afterTime)) {
      return true;
    } else {
      return false;
    }
  }
  static getDirectionAddress(dealer){
    const link = [];
    if (dealer.addressLine1) {
      link.push(dealer.addressLine1);
    }
    if (dealer.addressLine2) {
      link.push(dealer.addressLine2);
    }
    if (dealer.pinCode) {
      link.push(dealer.pinCode);
    }
    if (dealer.city) {
      link.push(dealer.city);
    }
    if (dealer.country) {
      link.push(dealer.country);
    }
    return link.join(', ');
  }
  static detectDevicePlatform(): string {
    const userAgent = navigator.userAgent;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'ios';
    } else if (/Android/.test(userAgent)) {
      return 'android';
    } else {
      return 'web';
    }    
  }
}

